import { Component, Input, OnInit } from '@angular/core';
import { TimeLap } from '../models/time_lap';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-time-laps',
  templateUrl: './time-laps.component.html',
  styleUrls: ['./time-laps.component.css'], 
})
export class TimeLapsComponent implements OnInit {
  constructor() {}
 @Input() timeLap!: TimeLap ;
  ngOnInit() {}
}
